import Vue from 'vue';
import Router from 'vue-router';
// 导入各个页面组件
import Home from '@/views/Home.vue'; // 首页
import Category from '@/views/Category.vue'; // 分类页面
import ProductDetail from '@/views/ProductDetail.vue'; // 商品详情页面
import Cart from '@/views/Cart.vue'; // 购物车页面
import Profile from '@/views/Profile.vue'; // 我的个人中心页面
import Login from '@/views/Login.vue'; // 登录页面

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/category',
      name: 'Category',
      component: Category
    },
    {
      path: '/product/:id',
      name: 'ProductDetail',
      component: ProductDetail
    },
    {
      path: '/cart',
      name: 'Cart',
      component: Cart
    },
    {
      path: '/profile',
      name: 'Profile',
      component: Profile
    },{
      path: '/login',
      name: 'Login',
      component: Login
    }
  ]
});